import { useState, useRef, ReactElement } from 'react';
import { List } from '@phosphor-icons/react';
import { getUrl, IDENTIFIERS } from 'helpers/urlsHelper';
import DropDown from '@/components/FormFields/DropDown';
import * as ApiModels from '@typings/api-models';
import Link from 'next/link';
import UserCircle from '@/components/Icons/UserCircle';
import { useUser } from '@/hooks';

import s from './MobileNav.module.scss';

type MobileNavProps = {
  consultationProduct?: unknown;
  creator: Partial<ApiModels.Creator> | null;
  enableServicesTab: boolean;
  showBroadcasts: boolean;
  showHandbooks: boolean;
  tab: string;
  setTab: (tab: string) => void;
};

const MobileNav = ({ consultationProduct, creator, enableServicesTab, showBroadcasts, showHandbooks, tab, setTab }: MobileNavProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const menuWrapperRef = useRef(null);
  const [user] = useUser();

  const menuItems = [];

  if (enableServicesTab) {
    menuItems.push({ label: 'Services', onClick: () => setTab('Services'), value: 'services' });
  }

  if (consultationProduct) {
    menuItems.push({
      label: 'Book a consultation',
      onClick: () => setTab('Bookings'),
      value: 'bookings',
    });
  }

  if (showBroadcasts) {
    menuItems.push({ label: 'Community', onClick: () => setTab('Broadcasts'), value: 'broadcasts' });
  }

  if (showHandbooks) {
    menuItems.push({ label: 'Library', onClick: () => setTab('Bytes'), value: 'bytes' });
  }

  menuItems.push({ label: 'Chat', onClick: () => setTab('Chat'), value: 'chat' });

  const tabLabels: Record<string, string> = {
    Bookings: 'Book a consultation',
    Broadcasts: 'Community',
    Bytes: 'Library',
    Chat: 'Chat',
    Services: 'Services',
  };

  return (
    <div className={s.navWrapper}>
      <nav className={s.navContainer}>
        <button className={s.navContainer__button} onClick={() => setIsOpen(true)} aria-label="Open menu" ref={menuWrapperRef}>
          <List size={16} />
          <span>{tabLabels[tab] ?? tab}</span>
        </button>
        {creator?.slug && <Link className={s.navContainer__signin} href={getUrl(IDENTIFIERS.USER_PROFILE, { creatorSlug: creator?.slug })}>
          <UserCircle size={16} />
          <span>{user ? 'Profile' : 'Log In'}</span>
        </Link>}
        {isOpen && (
          <DropDown
            id="mobile-nav-dropdown"
            value={tab.toLowerCase()}
            handleClose={() => setIsOpen(false)}
            isCentered
            isWidthFixed={false}
            itemHeight={40}
            menuItems={menuItems}
            menuWrapperEl={menuWrapperRef.current}
            withCloseOnSelect
          />
        )}
      </nav>

      <div className={s.navDivider} />
    </div>
  );
};

export default MobileNav;
